module.exports = __webpack_public_path__ + "img/oper-icon3.7c796e98.png";